import * as React from 'react'

import { observer } from 'mobx-react'

import Loading from 'modules/core/components/Loading'
import type { Model } from 'modules/core/lib/mobx-rest'

import { type ContractVersions } from 'modules/contracts/store/collections/contractVersions'
import { useResourceField } from 'modules/custom_resources/components/CustomFields/CustomFieldsBlock/useResourceField'
import FieldsForm from 'modules/custom_resources/components/CustomFields/CustomFieldsForm/FieldsForm'
import type ResourceField from 'modules/custom_resources/store/models/customFields/ResourceField'
import type Employee from 'modules/employees/store/models/Employee'

interface PayrollCustomFieldsBlockProps {
  usageGroups: string[]
  fieldableModelRef: string
  fieldableId: number
  valuableModelRef: string
  valuableInstance: Model
  employee?: Employee
  readonly?: boolean
  resourceFieldFilter?: (models: ResourceField[]) => ResourceField[]
  contractVersions: ContractVersions
}

const PayrollCustomFieldsBlock = ({
  usageGroups,
  fieldableModelRef,
  fieldableId,
  valuableModelRef,
  valuableInstance,
  employee,
  readonly,
  resourceFieldFilter,
  contractVersions,
}: PayrollCustomFieldsBlockProps) => {
  const { loading, filteredResourceFields, valuesCollection, createdValue } = useResourceField({
    usageGroups,
    fieldableModelRef,
    fieldableId,
    valuableModelRef,
    valuableInstance,
    employee,
    resourceFieldFilter,
  })

  if (loading) return <Loading />

  return (
    <FieldsForm
      employee={employee}
      fieldValues={valuesCollection}
      resourceFields={filteredResourceFields}
      createValue={createdValue}
      readonly={readonly}
      contractVersions={contractVersions}
    />
  )
}

export default observer(PayrollCustomFieldsBlock)
